import { render } from "./AccountCreate.vue?vue&type=template&id=70913aca"
import script from "./AccountCreate.vue?vue&type=script&lang=js"
export * from "./AccountCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__